<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
      <el-form-item label="天数">
        <el-input-number v-model="formLabelAlign.day" :min="0" label="请输入天数" />
      </el-form-item>
      <el-form-item label="消息数">
        <el-input-number v-model="formLabelAlign.limit" :min="0" label="请输入消息数" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setMessageNumber } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        day: null,
        limit: null,
        id: null
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      this.formLabelAlign.id = item.id
      this.formLabelAlign.day = item.threshold_day
      this.formLabelAlign.limit = item.threshold_limit
      console.log('item', item)
    },
    async sumbit() {
      if (this.formLabelAlign.day == null) {
        this.$message({
          message: '请填写天数',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.limit == null) {
        this.$message({
          message: '请输入消息数',
          type: 'error'
        })
        return
      }
      await setMessageNumber(this.formLabelAlign)
      this.$message({
        message: '设置成功',
        type: 'success'
      })
      this.$emit('setawrthreshold')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
